const API_BASE = process.env.REACT_APP_API_URL;
const DETALLE_API_URL = `${API_BASE}DetaParametros`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getDetalleByParametroId(parametroId) {
  const res = await fetch(`${DETALLE_API_URL}/por-parametro/${parametroId}`, {
    headers: getAuthHeaders()
  });
  return await res.json();
}

export function createDetalle(parametroId) {
  return async (values, onDone) => {
    try {
      await fetch(DETALLE_API_URL, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ...values,
          parametros_id: parametroId
        })
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export function editDetalle() {
  return async (row, values, onDone) => {
    try {
      await fetch(`${DETALLE_API_URL}/${row.id_detaparametro}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ...row,
          ...values
        })
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}

export function deleteDetalle() {
  return async (row, onDone) => {
    try {
      await fetch(`${DETALLE_API_URL}/${row.id_detaparametro}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      onDone(true);
    } catch {
      onDone(false);
    }
  };
}
